/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendRolePresetDto } from '../../models/backend-role-preset-dto';

export interface AccessRolePresetsList$Params {}

export function accessRolePresetsList(
  http: HttpClient,
  rootUrl: string,
  params?: AccessRolePresetsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendRolePresetDto>> {
  const rb = new RequestBuilder(rootUrl, accessRolePresetsList.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendRolePresetDto>;
    }),
  );
}

accessRolePresetsList.PATH = '/api/access/role-presets/';
